import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Expandable } from 'sharedComponents/Expandable';
import AssetListComponent from '../AssetListComponent';


// eslint-disable-next-line react/display-name
const ExpandableComponent = React.memo(({
    item,
    renderExpandableTitle,
    handlePowertrainClick,
    selectedPowertrain,
    selectedAsset,
    handleSelectedItem,
    handleAssetToggle,
    isHorizontalScrollActive,
    memoizedPowertrainOverviewList,
    translate,
    allAssets,
    model,
    isLabelVisible,
    leftPanelSize
}) => {
    return (
        <Suspense fallback={<div>Loading...</div>} key={item?.powertrainId}>
            <div data-powertrain-id={item?.powertrainId}>
                <Expandable
                    id={item?.powertrainId}
                    key={item?.powertrainId}
                    title={renderExpandableTitle(item)}
                    onClick={() => handlePowertrainClick(item)}
                    open={item?.powertrainId === selectedPowertrain}
                    isExpanderInsideContent={true}
                    type='powertrainV2'
                >
                    <Suspense fallback={<div>Loading...</div>} key={item?.powertrainId}>
                        <AssetListComponent
                            assets={item?.assets}
                            key={item?.powertrainId}
                            powertrainId={item?.powertrainId}
                            limitSummary={item?.limitSummary}
                            selectedAsset={selectedAsset}
                            allAssets={allAssets}
                            handleSelectedItem={handleSelectedItem}
                            handleAssetToggle={handleAssetToggle}
                            showThreshold={model?.showThreshold}
                            showTrend={model?.showTrend}
                            isHorizontalScrollActive={isHorizontalScrollActive}
                            memoizedPowertrainOverviewList={memoizedPowertrainOverviewList}
                            selectedPowertrain={selectedPowertrain}
                            translate={translate}
                            isLabelVisible={isLabelVisible}
                            leftPanelSize={leftPanelSize}
                        />
                    </Suspense>
                </Expandable>
            </div>
        </Suspense>
    );
});

ExpandableComponent.propTypes = {
    item: PropTypes.object.isRequired,
    renderExpandableTitle: PropTypes.func.isRequired,
    handlePowertrainClick: PropTypes.func.isRequired,
    selectedPowertrain: PropTypes.number,
    selectedAsset: PropTypes.object,
    handleSelectedItem: PropTypes.func.isRequired,
    handleAssetToggle: PropTypes.func.isRequired,
    isHorizontalScrollActive: PropTypes.bool,
    memoizedPowertrainOverviewList: PropTypes.array,
    translate: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    allAssets: PropTypes.array,
    isLabelVisible: PropTypes.bool
};

export default ExpandableComponent;
